import React, { useEffect, useState } from 'react';
import Template from '../components/Template';
import { ImageGallery } from "react-image-grid-gallery";
import LoadingSpinner from '../components/LoadingSpinner';
import './photos.css';

const { REACT_APP_AIRTABLE_API_TOKEN } = process.env;

export default function Photos() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true); // ← Added loading state

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          "https://api.airtable.com/v0/appXqP56p5bXn4bKa/Gallery%20Images",
          {
            headers: {
              'Authorization': `Bearer ${REACT_APP_AIRTABLE_API_TOKEN}`,
            },
          }
        );
        const responseData = await response.json();
        setData(responseData.records);
      } catch (error) {
        console.error('Error fetching data: ', error);
      } finally {
        setLoading(false); // ← Stop loading after fetch
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    const photosContainer = document.querySelector('.photos-container');
    if (!photosContainer) return;

    const images = photosContainer.querySelectorAll('img');

    const options = { threshold: 0.3 };
    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.transition = 'opacity 1s';
          entry.target.style.opacity = '1';
        } else {
          entry.target.style.opacity = '0';
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);
    images.forEach(image => observer.observe(image));

    return () => {
      observer.disconnect();
    };
  }, [data]);

  return (
    <Template>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="photos-container fade-in">
          <ImageGallery
            imagesInfoArray={data.map(item => ({
              alt: item.fields.caption,
              caption: item.fields.Caption,
              src: item.fields.Photo[0].url,
            }))}
            columnWidth={350}
            gapSize={24}
          />
        </div>
      )}
    </Template>
  );
}
